import { render } from "./IsletSpecificSectionDetails.vue?vue&type=template&id=a48ffd00&scoped=true"
import script from "./IsletSpecificSectionDetails.vue?vue&type=script&lang=js"
export * from "./IsletSpecificSectionDetails.vue?vue&type=script&lang=js"

import "./IsletSpecificSectionDetails.vue?vue&type=style&index=0&id=a48ffd00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48ffd00"],['__file',"src/components/IsletSpecificSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a48ffd00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a48ffd00', __exports__)) {
    api.reload('a48ffd00', __exports__)
  }
  
  module.hot.accept("./IsletSpecificSectionDetails.vue?vue&type=template&id=a48ffd00&scoped=true", () => {
    api.rerender('a48ffd00', render)
  })

}


export default __exports__